const n=function(){try{return"undefined"!=typeof window}catch(n){return!1}}(),t=!n;export{n as isBrowser,t as isServer};
//# sourceMappingURL=env.js.map
